const wijmoLocales = ['en', 'es', 'pt'];

function wijmoLocaleWithFallback(locale: string): string {
	if (wijmoLocales.indexOf(locale) !== -1) {
		return locale;
	} else {
		// If we don't find an exact match for the user locale,
		// See if we at least have that language
		const fallback = locale.substring(0, 2);
		if (wijmoLocales.indexOf(fallback) !== -1) {
			return fallback;
		}
	}
}

export function loadWijmoLocale(lang: string): void {
	const wjLocale = wijmoLocaleWithFallback(lang);
	if (!wjLocale) {
		return;
	}
	const langURL = `assets/@grapecity/wijmo.culture/wijmo.culture.${wjLocale}.js`;
	const cultureElement = document.getElementById('wijmoCultureScript') as HTMLScriptElement;
	if (!cultureElement) {
		const head = document.head || document.getElementsByTagName('head')[0];
		const node = document.createElement('script');
		// update wijmo culture when new script is loaded
		node.addEventListener('load', async () => {
			try {
				const { Control } = await import('@grapecity/wijmo');
				Control.invalidateAll();
			} catch (error) {
				console.error('Error during Wijmo culture update.', error);
			}
		});
		node.src = langURL;
		node.type = 'text/javascript';
		node.async = true;
		node.id = 'wijmoCultureScript';
		head.appendChild(node);
	} else {
		cultureElement.src = langURL;
	}
}
